import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FaBars, FaTimes } from "react-icons/fa";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="relative z-50 w-full px-6 py-4 ">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        {/* Logo Section - FIXED PATH */}
        <Link to="/" className="flex items-center gap-3 group">
          <img 
            src={process.env.PUBLIC_URL + '/logo.png'} 
            alt="All Stream Downloader Logo" 
            className="w-[300px] h-[90px] rounded-lg shadow-lg group-hover:shadow-cyan-500/50 transition-all object-cover"
          />
          {/* <span className="text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-purple-400">
            All Stream DOWNLOADER
          </span> */}
        </Link>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center gap-8">
          <Link to="/" className="hover:text-cyan-400 transition-colors font-medium">Home</Link>
          <Link to="/about" className="hover:text-cyan-400 transition-colors font-medium">About Us</Link>
          <Link to="/terms" className="hover:text-cyan-400 transition-colors font-medium">Terms</Link>
        </div>

        {/* Mobile Menu Button */}
        <button onClick={() => setIsOpen(!isOpen)} className="md:hidden text-2xl focus:outline-none text-white">
          {isOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="md:hidden absolute top-full left-0 w-full bg-gray-900/95 backdrop-blur-lg border-b border-white/10 py-4"
        >
          <div className="flex flex-col items-center gap-6">
            <Link to="/" onClick={() => setIsOpen(false)} className="text-lg hover:text-cyan-400">Home</Link>
            <Link to="/about" onClick={() => setIsOpen(false)} className="text-lg hover:text-cyan-400">About Us</Link>
            <Link to="/terms" onClick={() => setIsOpen(false)} className="text-lg hover:text-cyan-400">Terms</Link>
          </div>
        </motion.div>
      )}
    </nav>
  );
};

export default Navbar;